var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.5H5.5V11.5H18.5V12.5ZM22 12C22 17.514 17.514 22 12 22C6.48596 22 2 17.514 2 12C2 6.48596 6.48596 2 12 2C17.514 2 22 6.48596 22 12ZM21 12C21 7.03735 16.9626 3 12 3C7.03735 3 3 7.03735 3 12C3 16.9626 7.03735 21 12 21C16.9626 21 21 16.9626 21 12Z",
    fill: "#0096E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBlue);
export default __webpack_public_path__ + "static/media/remove-blue.6f627de9e0a0d4a39c46499046ab7997.svg";
export { ForwardRef as ReactComponent };